"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _Comment = _interopRequireDefault(require("../../../../Comment"));

require("../styles/_comment-group.scss");

function Group(a) {
  var b = a.group,
      c = b.comments,
      d = b.title,
      e = a.getCommentTitle,
      f = a.isGroupSelected,
      g = a.onSelectComment,
      h = a.selectedCommentId,
      i = a.commentIds;
  return _react["default"].createElement("div", {
    className: "comment-group"
  }, d ? _react["default"].createElement("p", {
    className: "comment-group__group-title"
  }, d) : null, c.map(function (a) {
    var b = a.commentId,
        c = i.indexOf(b);
    return _react["default"].createElement(_Comment["default"], {
      key: b,
      commentIndex: c,
      comment: a,
      getCommentTitle: e,
      isGroupSelected: f,
      onSelectComment: g,
      isCommentSelected: h === b
    });
  }));
}

var _default = Group;
exports["default"] = _default;